import React, { useEffect } from "react";
import { Toast } from "flowbite-react";

function ToastNotification({ message, show, icon, onClose, actions }) {
  if (!show) return null;

  return (
    <div className="fixed w-full max-w-xs "
      style={{ top: "70px", right: "16px" }}
    >
      <Toast className="dark:bg-gray-700">
        {icon && <div className="h-5 w-5 ">{icon}</div>}
        {/* <div className="pl-4 text-sm font-normal overflow-wrap text-breack mr-4">{message}</div> */}
        <div className="pl-4 text-sm font-normal break-words mr-4">{message}</div>

        {/* Butonul de închidere */}
        <button
          className="absolute top-0 right-0 p-2 text-gray-500"
          onClick={onClose} // Apelăm onClose la click pe butonul "x"
        >
          ×
        </button>
      </Toast>
    </div>
  );
};

export default ToastNotification;
